import { getUpdateStatusApi } from "../../api/api";
const urlParams = new URLSearchParams(window.location.search);
const status = urlParams.get('status');

export const getUpdateStatus = (apiName: string, error: any) => {

    if (status === "success") {
        getUpdateStatusApi(apiName, error).then((response) => {
            console.log(response);
        })
    }
}